<div class="voices-top-section">
    <div class="app-l-container">
        <div class="app-l-page__navigation">
            <div class="app-l-page__previous" (click)="goBack()">
                <button
                    class="app-c-btn app-c-btn--icon app-c-btn--icon-secondary app-c-btn--icon-20">
                    <svg-icon icon="arrowLeft" class="w-100 h-100"></svg-icon>
                </button>
            </div>
            <nav class="app-l-page__breadcrumbs" aria-label="Breadcrumb" *ngIf="showBreadcrumbs">
                <ul class="breadcrumbs-list">
                    <li class="breadcrumbs-list-item">
                        <a
                            [routerLink]="['/app/series']"
                            translate
                            aria-current="false">
                            series.title
                        </a>
                    </li>
                    <li
                        class="breadcrumbs-list-item">
                        <a
                            [routerLink]="['/app/series/org-series-contents']"
                            translate
                            aria-current="false">
                            {{ organizationOwnContentTitle }}
                        </a>
                    </li>
                    <li
                        class="breadcrumbs-list-item app-l-current-page"
                        aria-current="page" translate>
                        {{ title }}
                    </li>
                </ul>
            </nav>
        </div>
        <div class="app-l-voices-banner">
            <div class="app-l-voices-banner__left">
                <h1 class="app-l-voices-banner__heading" translate>
                    {{title}}
                </h1>
            </div>
        </div>
    </div>
</div>
<page-loader *ngIf="!viewAllListLoaded"></page-loader>

<div class="app-l-page-wrap" *ngIf="viewAllListLoaded">
    <div id="page-theory" *ngIf="type === 'videos' && videoSeriesList.length > 0">

        <div class="app-l-course__list">
            <div
                class="app-l-course__items"
                *ngFor="let item of videoSeriesList">
                <div class="course-card">
                    <div class="card-body">
                        <div class="app-l-course__image">
                            <img
                                class="img-responsive"
                                [defaultImage]="
                                    './assets/img/course_image_default.svg'
                                "
                                [lazyLoad]="item.courseImage" />
                            <div class="app-l-course__cnt">
                                <div class="app-l-course__length">
                                    <span translate
                                        >theory.length
                                        <span class="app-l-length__duration">{{
                                            item.length
                                        }}</span>
                                    </span>
                                    
                                </div>
                                <h3
                                    class="app-l-course__title"
                                    aria-live="polite"
                                    tabindex="0"
                                    translate>
                                    {{ item.name }}
                                </h3>
                            </div>

                            <div translate class="app-l-course__video-status">
                                <div
                                    *ngIf="
                                        !item.completed &&
                                        item.courseProgress === 'inprogress'
                                    "
                                    class="app-l-course__badge app-l-course__badge-inprogress">
                                    <svg-icon
                                        icon="timer"
                                        class="app-l-course__badge-icon"
                                        alt="timer"></svg-icon>
                                    <span
                                        class="app-l-course__badge-text"
                                        translate
                                        >theory.inProgress</span
                                    >
                                </div>
                                <div
                                    *ngIf="item.completed"
                                    class="app-l-course__badge app-l-course__badge-completed">
                                    <svg-icon
                                        icon="tick-circle"
                                        class="app-l-course__badge-icon"
                                        alt="tick-circle"></svg-icon>
                                    <span
                                        class="app-l-course__badge-text"
                                        translate
                                        >theory.completed</span
                                    >
                                </div>
                            </div>
                        </div>
                        <div class="card-content">
                            <p [innerHtml]="item.description"></p>
                        </div>
                    </div>
                    <div class="card-footer">
                        <button
                            tabindex="0"
                            class="app-c-btn app-c-btn--secondary app-c-btn--curve"
                            aria-label="start video button"
                            translate
                            (click)="goToVideoSeries(item)"
                            (keypress)="goToVideoSeries(item)">
                            {{
                                item.completed
                                    ? 'theory.restart'
                                    : 'theory.start'
                            }}
                        </button>
                        <span class="app-l-course-video-count"
                            >{{ item.videoCount }}
                            <span translate>theory.videos</span></span
                        >
                    </div>
                    <div class="clearfix"></div>
                </div>
            </div>
        </div>
        <ng-container *ngIf="videoSeriesList.length === 0">
            <div class="empty-card">
                <div class="app-dm-positive-cards" translate>series.noData</div>
            </div>
        </ng-container>
    </div>
    <div
        id="page-audios" *ngIf="type === 'stories' && storySeriesList.length > 0">
        <div class="series-type-section">
            <div class="series-type-list">
                <ng-container *ngFor="let voice of storySeriesList">
                    <div
                        class="series-type-card type-allen">
                        <div
                            class="cover-image-section default-bg"
                            (click)="goToVoice('stories', voice)">
                            <img
                                [defaultImage]="
                                    '../../../assets/img/series/voice-stories-bg.svg'
                                "
                                [lazyLoad]="voice.imageUrl" />

                            <div class="card-content" translate>
                                {{ voice ? voice['title_' + lang] : '' }}
                                <span>{{
                                    voice ? voice['author_' + lang] : ''
                                }}</span>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
        <ng-container *ngIf="storySeriesList.length === 0">
            <div class="empty-card">
                <div class="app-dm-positive-cards" translate>series.noData</div>
            </div>
        </ng-container>
    </div>
    <div
        id="page-audios" *ngIf="type === 'burningQuestions' && bqSeriesList.length > 0">
        <div class="series-type-section">
            <div class="series-type-list">
                <ng-container *ngFor="let voice of bqSeriesList">
                    <div
                        class="app-l-burning-questions-holder">
                        <div
                            class="app-l-burning-questions-holder_items"
                            (click)="goToVoice('burningQuestions', voice)">
                            <div class="app-l_container">
                                <div class="app-l-content">
                                    <span>{{
                                        voice ? voice['title_' + lang] : ''
                                    }}</span>
                                    <img
                                        class="bg-img"
                                        [defaultImage]="
                                            '../../../assets/img/series/voice-bq-default.svg'
                                        "
                                        [lazyLoad]="voice.imageUrl" />
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
        <ng-container *ngIf="bqSeriesList.length === 0">
            <div class="empty-card">
                <div class="app-dm-positive-cards" translate>series.noData</div>
            </div>
        </ng-container>
    </div>
    <div
        id="page-audios" *ngIf="type === 'reads' && readableSeriesList.length > 0">
        <div class="series-type-section">
            <div class="series-type-list">
                <ng-container *ngFor="let item of readableSeriesList">
                    <div
                        class="series-type-card" (click)="goToReadableSeries(item)">
                        <div class="cover-image-section readable-section">
                            <img [defaultImage]="'../../../../assets/img/series/reads-default.svg'" [lazyLoad]="item.thumbnailUrl" />
                        </div>
                        <div class="card-content readable-section">
                            <h2 class="app-l-course__title">{{ item['title' + lang]}}</h2>
                        </div>
                        
                    </div>
                </ng-container>
            </div>
        </div>
        <ng-container *ngIf="readableSeriesList.length === 0">
            <div class="empty-card">
                <div class="app-dm-positive-cards" translate>series.noData</div>
            </div>
        </ng-container>
    </div>
    </div>